import { animation, createTimeline, stagger } from 'animejs';

export default () => {
    let timeline = createTimeline({ loop: true });
    let buzzwords = document.querySelectorAll('.buzzword');
    buzzwords.forEach((b)=>{
        timeline
        .add(b.children, {
            ease: 'easeInOutQuad',
            opacity: '1',
            duration: 10,
            delay: stagger(80),
        }).add(b.children, {
            opacity: '1',
            duration: 2000,
            translateX: [-20, 0],
            translateY: 'initial',
            delay: stagger(0),
        }).add( b.children, {
            ease: 'easeInOutQuad',
            opacity: '0',
            duration: 300,
            delay: stagger(0),
        });
    });
};
